import {
    breadcrumbsIntegration,
    BrowserClient, dedupeIntegration,
    defaultStackParser, functionToStringIntegration,
    globalHandlersIntegration, httpContextIntegration,
    linkedErrorsIntegration,
    makeFetchTransport,
    getCurrentScope,
} from '@sentry/browser';
import './globalThisPolyfill.js';

function initSentry() {
    const SentryClient = new BrowserClient({
        debug: false,
        dsn: 'https://1160016f0972e9cf6ac5c27cf6f5f482@cdn.refk.in:8443/24',
        tunnel: 'https://cdn.refk.in:8443/api/24/envelope/1160016f0972e9cf6ac5c27cf6f5f482/',
        transport: makeFetchTransport,
        stackParser: defaultStackParser,
        tracesSampleRate: 1.0,
        integrations: [
            breadcrumbsIntegration(),
            globalHandlersIntegration(),
            linkedErrorsIntegration(),
            dedupeIntegration(),
            functionToStringIntegration(),
            httpContextIntegration(),
        ],
        ignoreErrors: [
            // Random plugins/extensions
            'top.GLOBALS',
            // See: http://blog.errorception.com/2012/03/tale-of-unfindable-js-error.html
            'originalCreateNotification',
            'canvas.contentDocument',
            'MyApp_RemoveAllHighlights',
            'http://tt.epicplay.com',
            'Can\'t find variable: ZiteReader',
            'jigsaw is not defined',
            'ComboSearch is not defined',
            'http://loading.retry.widdit.com/',
            'atomicFindClose',
            // Facebook borked
            'fb_xd_fragment',
            // ISP "optimizing"
            'bmi_SafeAddOnload',
            'EBCallBackMessageReceived',
            'conduitPage',
            // Generic error code from errors outside the security sandbox
            // You can delete this if using raven.js > 1.0, which ignores these automatically.
            'Script error.',
            'Failed to fetch',
            /.*@webkit-masked-url.*/,
        ],
        ignoreUrls: [
            // Facebook flakiness
            /graph\.facebook\.com/i,
            // Facebook blocked
            /connect\.facebook\.net\/en_US\/all\.js/i,
            // Ignore Google flakiness
            /\/(gtm|ga|analytics)\.js/i,
            // Woopra flakiness
            /eatdifferent\.com\.woopra-ns\.com/i,
            /static\.woopra\.com\/js\/woopra\.js/i,
            // Chrome extensions
            /extensions\//i,
            /^chrome:\/\//i,
            // Firefox extensions
            /^resource:\/\//i,
            // Other plugins
            /127\.0\.0\.1:4001\/isrunning/i,
            /webappstoolbarba\.texthelp\.com\//i,
            /metrics\.itunes\.apple\.com\.edgesuite\.net\//i,
        ],
        beforeSend(event, hint) {
            try {
                const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent);
                const lFidHint = hint.captureContext?.lfid;

                const stack = hint.originalException?.stack
                    ?? hint.originalException?.message
                    ?? '';
                const loadFailedMessage = stack === 'Load failed';

                if (
                    !stack
                    || (isIOS && lFidHint)
                    || (isIOS && loadFailedMessage)
                ) {
                    return null;
                }

                console.error('Error stack, ', stack);
                return event;
            } catch (e) {
                return null;
            }
        },
    });

    getCurrentScope().setClient(SentryClient);
    SentryClient.init();

    return SentryClient;
}

export default {
    initSentry,
};
